<template>
  <div class="pbc">
    <el-radio-group class="switch"
                    v-model="active"
                    @change="handleClick">
      <el-radio-button v-if="getSite.hasInterim"
                       label="1">{{$t('COMMON_INTERIM')}}</el-radio-button>
      <el-radio-button label="2">{{$t('COMMON_FINAL')}}</el-radio-button>
    </el-radio-group>
    <el-table v-show="active=='1'"
              :data="initData.interimPbcList"
              v-loading="loading"
              height="300"
              border
              stripe
              @selection-change="handleSelectionChangeInterim"
              class="wl-table interimTable">

      <el-table-column type="selection"
                       width="40"></el-table-column>
      <el-table-column prop="groupName"
                       width="180"
                       show-overflow-tooltip
                       :label="$t('PAGE_PBCLIST_NAME')">
      </el-table-column>
      <el-table-column width="160"
                       :label="$t('TABLE_HEADER_periodEndDate')">
        <template slot-scope="scope">
          {{formatDate(scope.row.periodEndDate)}}
        </template>
      </el-table-column>
      <el-table-column prop="detailedInfoReq"
                       :label="$t('TABLE_HEADER_detailedInfoReq')"></el-table-column>
      <el-table-column width="140"
                       :label="$t('TABLE_HEADER_DETAILS')">
        <template slot-scope="scope">
          <el-button @click="details(scope.row)"
                     type="text">{{$t('COMMON_VIEW')}}</el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-table v-show="active=='2'"
              :data="initData.finalPbcList"
              v-loading="loading"
              height="300"
              border
              stripe
              @selection-change="handleSelectionChangeFinal"
              class="wl-table finalTable">

      <el-table-column type="selection"
                       width="40"></el-table-column>
      <el-table-column prop="groupName"
                       width="180"
                       :label="$t('PAGE_PBCLIST_NAME')">
      </el-table-column>
      <el-table-column width="160"
                       :label="$t('TABLE_HEADER_periodEndDate')">
        <template slot-scope="scope">
          {{formatDate(scope.row.periodEndDate)}}
        </template>
      </el-table-column>
      <el-table-column prop="detailedInfoReq"
                       :label="$t('TABLE_HEADER_detailedInfoReq')"></el-table-column>
      <el-table-column width="140"
                       :label="$t('TABLE_HEADER_DETAILS')">
        <template slot-scope="scope">
          <el-button @click="details(scope.row)"
                     type="text">{{$t('COMMON_VIEW')}}</el-button>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { dateFormat } from '@/utils'
export default {
    data() {
        return {
            chosenListInterim: [],
            chosenListFinal: [],
            active: ''
        }
    },
    methods: {
        handleClick() {
            this.onChangeAcitve(this.active)
        },
        handleSelectionChangeInterim(v) {
            this.chosenListInterim = v
        },
        handleSelectionChangeFinal(v) {
            this.chosenListFinal = v
        },
        onConfirm() {
            const chosenList = this.chosenListInterim.concat(this.chosenListFinal)
            this.onPbcList(_.map(chosenList, v => v.id))
        },
        details(row) {
            this.$router.push({ path: '/new-pbc-list', query: { audit: this.active, id: row.id ,edit:'N'} })
        },
        formatDate: value => {
            if (value != null) {
                return dateFormat(new Date(value), 'yyyy-MM-dd')
            } else {
                return value
            }
        }
    },
    mounted() {
        this.active = this.getSite.hasInterim ? '1' : '2'
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite'
        })
    },
    props: {
        initData: {
            type: [Array, Object],
            default: []
        },
        onPbcList: {
            type: Function,
            default: () => {}
        },
        loading: Boolean,
        onChangeAcitve: {
            type: Function,
            default: () => {}
        }
    }
}
</script>
<style scoped>
.pbc {
    padding: 0 10px;
    margin-top: -35px;
}

.wl-table {
    margin-bottom: 6px;
}

.switch {
    float: right;
    margin: 0 10px 10px 0;
}
</style>
